module.exports = __webpack_public_path__ + "static/media/icon-lock.d0ba3a2e.svg";